import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: true,
    partyGstdetails: '',
    productGstdetails: '',
    currencyDetails: '',
    error: '',
    walletDetails: '',
    mopDetails: '',
    hsnDetails: '',
    taxCodedetails: '',
    otherTaxesdetails: '',
    hsnLoader: false,
};

export default function adminSetupReducer(state = initState, action) {
    switch (action.type) {
        case actions.PRODUCTGST_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.PRODUCTGST_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                productGstdetails: action.payload,
            };
        }
        case actions.PRODUCTGST_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.TAXCODE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.TAXCODE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                taxCodedetails: action.payload,
            };
        }
        case actions.TAXCODE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.OTHERTAXES_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.OTHERTAXES_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                otherTaxesdetails: action.payload,
            };
        }
        case actions.OTHERTAXES_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CASHDISCOUNT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.CASHDISCOUNT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                cashDiscountDetails: action.payload,
            };
        }
        case actions.CASHDISCOUNT_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.PARTYGST_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.PARTYGST_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                partyGstdetails: action.payload,
            };
        }
        case actions.PARTYGST_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CURRENCY_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.CURRENCY_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                currencyDetails: action.payload.filter(function (el) { return el.id === 45 })
            };
        }
        case actions.CURRENCY_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.WALLET_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.WALLET_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                walletDetails: action.payload,
            };
        }
        case actions.WALLET_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.MOP_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.MOP_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                mopDetails: action.payload,
            };
        }
        case actions.MOP_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.HSN_DETAILS_START: {
            return {
                ...state,
                hsnLoader: true,
            };
        }
        case actions.HSN_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                hsnLoader: false,
                hsnDetails: action.payload,
            };
        }
        case actions.HSN_DETAILS_FAILURE: {
            return {
                ...state,
                hsnLoader: false,
                error: action.message,
            };
        }
        default:
            return state;
    }
}